import { render } from "./Plugin.vue?vue&type=template&id=08380881&scoped=true"
import script from "./Plugin.vue?vue&type=script&lang=js"
export * from "./Plugin.vue?vue&type=script&lang=js"

import "./custom-plugin.scss?vue&type=style&index=0&id=08380881&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08380881"]])

export default __exports__